import { render, staticRenderFns } from "./Bangbangzhuanmai.vue?vue&type=template&id=24d06b16&scoped=true&"
import script from "./Bangbangzhuanmai.vue?vue&type=script&lang=js&"
export * from "./Bangbangzhuanmai.vue?vue&type=script&lang=js&"
import style0 from "./Bangbangzhuanmai.vue?vue&type=style&index=0&id=24d06b16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d06b16",
  null
  
)

export default component.exports